import React, {Component} from 'react'
import styles from './FJPreviewLink.module.less';
import FJLocalStore from "../../../store/FJLocalStore";
import InlineSVG from "react-inlinesvg";
import relink from '../../../icon/relink.svg';

class FJPreviewLink extends Component {

  render() {
    return (
      <div className={styles.links}>
        <InlineSVG src={relink} element='div' />
        <div className={styles.desc}>{FJLocalStore._('preview-please-relink-missing-files')}</div>
      </div>
    )
  }
}

export default FJPreviewLink;
